import { useEffect, useRef, useState } from 'react';
import { BunkerBadge } from './components/bunker-badge';
import { DataCardBadge } from './components/data-card';
import { MixStepsBadge } from './components/mix-steps';
import { SchiberBadge } from './components/schiber';
import { TotalCardBadge } from './components/total-card';
import styles from './multi-bunker.module.sass';
import multiBunker from '@/modules/mixing/images/multi-bunker.png';
import classNames from 'classnames';
import { ArrowMulti, EqualSign } from '../../images';
import ArrowUp from '../../images/arrow-up.svg';
import { RecipeWidget } from '../recipe-widget';
import { TopWidget } from '../top-widget';

export const MultiBunker = ({
  displayModal,
  data,
  activePair,
  setActivePair,
}: IMultiBunker) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  // const mockData = {
  //   gluten: 0,
  //   idk: 0,
  //   protein: 0,
  //   humidity: 0,
  //   cp: 0,
  //   nature: 0,
  // };

  return (
    <div
      className={styles.body}
      style={
        {
          //transform: windowWidth > 1680 ? 'scale(1.25)' : 'none',
        }
      }
    >
      <TopWidget data={data} activePair={activePair} setActivePair={setActivePair} />
      <div className={styles.content}>
        <div className={styles.firstRow}>
          <SchiberBadge multi={false} mirroring={true} />
          <MixStepsBadge
            stepsCount={data?.steps[activePair]?.steps.length}
            onClick={displayModal}
          />
          <SchiberBadge multi={false} />
        </div>
        <div className={styles.secondRow}>
          <DataCardBadge
            data={data?.part_one.params}
            weight={data?.steps[activePair]?.info?.part_one.weight}
            id={data?.steps[activePair]?.info?.part_one.bag_id}
            title={data?.steps[activePair]?.info?.part_one?.warehous_name}
            price={data?.steps[activePair]?.info?.part_one.price}
          />
          <TotalCardBadge
            totalData={data}
            data={data?.result?.params}
            weight={data?.steps[activePair]?.info?.result.weight}
            price={data?.steps[activePair]?.info?.result.price}
            profit={data?.steps[activePair]?.info?.result.price_delta}
          />
          <DataCardBadge
            data={data?.part_two.params}
            weight={data?.steps[activePair]?.info?.part_two.weight}
            id={data?.steps[activePair]?.info?.part_two.bag_id}
            title={data?.steps[activePair]?.info?.part_two.warehous_name}
            price={data?.steps[activePair]?.info?.part_two.price}
          />
        </div>
        <div className={styles.thirdRow}>
          <BunkerBadge label={data?.steps[activePair]?.bp_name_1} />
          <BunkerBadge label={data?.steps[activePair]?.bp_name_2} />
        </div>
      </div>

      <img className={styles.bodyBg} src={multiBunker} alt="bunker" />
    </div>
  );
};

interface IMultiBunker {
  displayModal: () => void;
  data: any;
  activePair: number;
  setActivePair: (val: number) => void;
}
